import { render } from "./listApproverPopup.vue?vue&type=template&id=851fe6de"
import script from "./listApproverPopup.vue?vue&type=script&lang=js"
export * from "./listApproverPopup.vue?vue&type=script&lang=js"

import "./listApproverPopup.vue?vue&type=style&index=0&id=851fe6de&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__